import { Box, IconButton, Typography } from "@mui/material"
import { EditOutlined } from "@mui-symbols-material/w300"
import type { ReactElement } from "react"

import { ProductOriginGridHeader } from "@/screens/Products/components/Product/Information/Origin/ProductOriginGridHeader"
import { ProductOriginGridValues } from "@/screens/Products/components/Product/Information/Origin/ProductOriginGridValues"

interface ProductOriginGridProps {
  shippingOrigin: {
    address: string
    country: string
    city: string
  }
  manufacturingOrigin: {
    country: string
    region: string
    city: string
    address: string | null
  }
  countryOrigin: {
    country: string
    region: string
    city: string
    address: string | null
  }
  onEdit: () => void
  isPastProductVersion: boolean
}

export const ProductOriginGrid = ({
  shippingOrigin,
  manufacturingOrigin,
  countryOrigin,
  onEdit,
  isPastProductVersion,
}: ProductOriginGridProps): ReactElement => {
  return (
    <Box
      className='grid grid-cols-8 divide-x divide-y divide-gray-200 border border-gray-200'
      data-testid='product-origin-grid'
    >
      <Box className='col-span-1 flex items-center bg-gray-300 p-4' data-testid='shipping-origin-header'>
        <Typography variant='subtitle2' className='font-medium text-gray-700'>
          Shipping Origin
        </Typography>
      </Box>
      <Box className='col-span-3 flex items-center bg-gray-200 p-4' data-testid='country-origin-header'>
        <Typography variant='subtitle2' className='font-medium text-gray-700'>
          Country of Origin
        </Typography>
      </Box>
      <Box className='col-span-4 flex items-center bg-gray-100 p-4' data-testid='manufacturing-origin-header'>
        <Typography variant='subtitle2' className='font-medium text-gray-700'>
          Manufacturing Location
        </Typography>
      </Box>
      <Box className='flex items-center p-4' data-testid='ship-from-label'>
        <Typography variant='body2' className='font-medium text-gray-700'>
          Ship From
        </Typography>
      </Box>
      <ProductOriginGridHeader address={countryOrigin.address} testIdPrefix='country-origin' />
      <ProductOriginGridHeader address={manufacturingOrigin.address} testIdPrefix='manufacturing-origin' />
      <Box
        className='flex items-center justify-end p-4'
        sx={{ borderLeft: "none", borderBottom: "1px solid grey" }}
        data-testid='edit-button-container'
      >
        {!isPastProductVersion && (
          <IconButton onClick={onEdit} color='primary' data-testid='edit-button' aria-label='Edit product origin'>
            <EditOutlined />
          </IconButton>
        )}
      </Box>

      <Box className='flex items-center p-4' data-testid='shipping-origin-address'>
        <Typography variant='body2'>{shippingOrigin.address || "-"}</Typography>
      </Box>
      <ProductOriginGridValues productOrigin={countryOrigin} testIdPrefix='country-origin' />
      <ProductOriginGridValues productOrigin={manufacturingOrigin} testIdPrefix='manufacturing-origin' />
    </Box>
  )
}
